import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Lock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-brand-darker border-t border-slate-800 relative overflow-hidden" data-id="element-111">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-brand-accent/5 blur-[100px] rounded-full pointer-events-none" data-id="element-112" />

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-113">
        <FadeIn className="text-center mb-12" data-id="element-114">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" data-id="element-115">
            Los que entren hoy no solo compran el MegaPack: entran al ecosistema
            de Librofy.store.
          </h2>
          <p className="text-lg text-slate-300 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-116">
            Eso incluye acceso a futuros PDFs con prompts y materiales
            exclusivos que iremos liberando para miembros.
          </p>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-117">
          {/* Tier 1 */}
          <FadeIn delay={0.1} data-id="element-118">
            <div className="bg-brand-card border border-slate-700 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-119">
              <div data-id="element-120">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-121">
                  📘 MEGAPACK CONTADOR PRO
                </h3>
                <p className="text-slate-400 text-sm mb-2" data-id="element-122">
                  6 Tomos + 4 Bonos · Para el contador que quiere recuperar su
                  tiempo
                </p>
                <div className="flex items-baseline gap-2" data-id="element-123">
                  <span className="text-slate-500 line-through text-sm" data-id="element-124">
                    $51.000
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-125">
                    $19.990 ARS
                  </span>
                </div>
              </div>
              <Button href="https://librofy.store/products/megapack-contador-pro?variant=47834891485405" variant="outline" className="w-full md:w-auto whitespace-nowrap" data-id="element-126">
                → QUIERO MI MEGAPACK
              </Button>
            </div>
          </FadeIn>

          {/* Tier 2 */}
          <FadeIn delay={0.2} data-id="element-127">
            <div className="bg-gradient-to-r from-brand-card to-brand-darker border-2 border-brand-accent rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-[0_0_30px_rgba(245,158,11,0.1)]" data-id="element-128">
              <div data-id="element-129">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-130">
                  🏆 MEGAPACK PRO + SISTEMA CLIENTES ⭐
                </h3>
                <p className="text-brand-accent text-sm mb-2 font-medium" data-id="element-131">
                  6 Tomos + 4 Bonos + Kit de Captación Premium
                </p>
                <div className="flex items-baseline gap-2" data-id="element-132">
                  <span className="text-slate-500 line-through text-sm" data-id="element-133">
                    $69.000
                  </span>
                  <span className="text-3xl font-bold text-white" data-id="element-134">
                    $27.990 ARS
                  </span>
                </div>
              </div>
              <Button href="https://librofy.store/products/megapack-contador-pro?variant=47834891485405" className="w-full md:w-auto whitespace-nowrap" data-id="element-135">
                → QUIERO EL PRO + SISTEMA CLIENTES
              </Button>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-136">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-2 text-sm text-slate-400 max-w-xl mx-auto mb-16" data-id="element-137">
            <div className="flex items-center justify-center gap-2" data-id="element-138">
              <Lock className="w-4 h-4 text-brand-accent" data-id="element-139" /> Pago 100% seguro
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-140">
              <Zap className="w-4 h-4 text-brand-accent" data-id="element-141" /> Acceso en 5 min
            </div>
            <div className="flex items-center justify-center gap-2 col-span-2 md:col-span-1" data-id="element-142">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-143" /> Garantía 45
              días
            </div>
            <div className="flex items-center justify-center gap-2 col-span-2 md:col-span-1" data-id="element-144">
              <CreditCard className="w-4 h-4 text-brand-accent" data-id="element-145" /> Mercado Pago
              / Tarjeta
            </div>
            <div className="flex items-center justify-center gap-2 col-span-2" data-id="element-146">
              <span className="text-brand-accent" data-id="element-147">🇦🇷</span> Diseñado para
              contadores argentinos
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="text-center border-t border-slate-800 pt-12" data-id="element-148">
          <div className="text-2xl font-bold text-white mb-4" data-id="element-149">
            🏪 LIBROFY.STORE™
          </div>
          <p className="text-slate-400 mb-2" data-id="element-150">
            El sistema N°1 de automatización profesional para contadores
            independientes de Argentina.
          </p>
          <p className="text-brand-accent font-medium mb-8" data-id="element-151">
            Porque llevar la contabilidad de otros no debería costarte todos los
            martes de tu vida.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500 mb-12" data-id="element-152">
            <a href="mailto:hola@librofy.store" className="hover:text-brand-accent transition-colors" data-id="element-153">
              📧 hola@librofy.store
            </a>
            <span className="hover:text-brand-accent transition-colors cursor-pointer" data-id="element-154">
              📲 @librofy.store
            </span>
            <a href="https://www.librofy.store" className="hover:text-brand-accent transition-colors" data-id="element-155">
              🌐 www.librofy.store
            </a>
          </div>

          <p className="text-xs text-slate-600 mb-4" data-id="element-156">
            © Librofy™ 2024 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-sm text-slate-500 italic" data-id="element-157">
            "El próximo martes a las 11:30 PM puede ser diferente." —
            Librofy.store
          </p>
        </FadeIn>
      </div>
    </section>;
}